import { Box, Typography, useTheme } from '@mui/material';

const StationSidebar = ({ stations, selectedStation, onSelect, dayFlights, airportMap }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 1, py: 0.75,
          bgcolor: 'background.dark',
          borderBottom: `1px solid ${theme.palette.divider}`,
          flexShrink: 0,
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight="bold">
          Stations ({stations.length})
        </Typography>
      </Box>

      {/* Scrollable list */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        {stations.map((iata) => {
          const depCount = dayFlights.filter((f) => f.dep === iata).length;
          const arrCount = dayFlights.filter((f) => f.arr === iata).length;
          const ap       = airportMap[iata];
          const isActive = selectedStation === iata;

          return (
            <Box
              key={iata}
              onClick={() => onSelect(iata)}
              sx={{
                px: 1, py: 0.5,
                cursor: 'pointer',
                bgcolor: isActive ? 'primary.main' : 'transparent',
                color: isActive ? 'primary.contrastText' : 'text.primary',
                borderBottom: `1px solid ${theme.palette.divider}`,
                '&:hover': { bgcolor: isActive ? 'primary.dark' : 'action.hover' },
              }}
            >
              <Typography variant="body2" fontFamily="monospace" fontWeight="bold">{iata}</Typography>
              {ap?.city && (
                <Typography
                  variant="caption"
                  noWrap
                  display="block"
                  sx={{ color: isActive ? 'rgba(255,255,255,0.8)' : 'text.secondary', fontSize: '0.6rem' }}
                >
                  {ap.city}
                </Typography>
              )}
              <Typography
                variant="caption"
                sx={{ color: isActive ? 'rgba(255,255,255,0.75)' : 'text.secondary', fontSize: '0.6rem' }}
              >
                {depCount}D {arrCount}A
              </Typography>
            </Box>
          );
        })}

        {stations.length === 0 && (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="caption" color="text.disabled">No stations</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default StationSidebar;
